"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceInfo = void 0;
const model_1 = require("../data/model");
const discovery_1 = require("../mesh/agents/discovery");
class SpaceInfo extends model_1.HashedObject {
    constructor(entryPoint) {
        super();
        if (entryPoint !== undefined) {
            this.entryPoint = entryPoint;
            this.hashSuffixes = SpaceInfo.createHashSuffixes(this.entryPoint);
        }
    }
    getClassName() {
        return SpaceInfo.className;
    }
    init() {
    }
    async validate(references) {
        references;
        if (this.entryPoint === undefined || this.hashSuffixes === undefined) {
            return false;
        }
        const hashSuffixes = SpaceInfo.createHashSuffixes(this.entryPoint);
        if (this.hashSuffixes.length !== hashSuffixes.length) {
            return false;
        }
        for (let i = 0; i < hashSuffixes.length; i++) {
            if (this.hashSuffixes[i] !== hashSuffixes[i]) {
                return false;
            }
        }
        return true;
    }
    static createHashSuffixes(entryPoint) {
        const hash = entryPoint.hash();
        const hashSuffixes = new Array();
        for (const bitLength of SpaceInfo.bitLengths) {
            hashSuffixes.push(new model_1.HashedLiteral(discovery_1.ObjectBroadcastAgent.hexSuffixFromHash(hash, bitLength)));
        }
        return hashSuffixes;
    }
}
exports.SpaceInfo = SpaceInfo;
SpaceInfo.className = 'hhs/v0/SpaceInfo';
SpaceInfo.bitLengths = [11 * 4, 12 * 5, 12 * 4, 12 * 3];
model_1.HashedObject.registerClass(SpaceInfo.className, SpaceInfo);
//# sourceMappingURL=SpaceInfo.js.map